import transEnumsI18n from "./transEnumsI18n";
import getDiffFormatValue from "./getDiffFormatValue";
import type { Config, Option } from "../type";
import type { EnumItem } from "@/services/common/type";
import { getT } from "@/utils/intlUtils";

const getOptionEnums = (config: Config, pointedEnum: EnumItem[] = []) => {
  const { keyFormat, omit = [], isAll } = config;

  const options: Option[] = [];

  if (isAll) {
    const t = getT();
    options.push({ value: "", label: t("全部") });
  }

  pointedEnum.forEach((item) => {
    const option: Option = {
      label: transEnumsI18n(item.groupCode, item.value),
      value: getDiffFormatValue(item.value, keyFormat),
    };

    options.push(option);
  });

  if (omit.length !== 0) {
    const omitSet = new Set([...omit]);
    return options.filter((x) => !omitSet.has(x.value));
  }

  return options;
};

export default getOptionEnums;
